exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body, body * {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  overflow-y: scroll;\r\n}\r\n\r\n.App {\r\n  position: relative;\r\n}\r\n\r\n.Card {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 15px;\r\n}\r\n\r\n.Card__centering {\r\n  height: 100%;\r\n}\r\n\r\n.Card__centering,\r\n.Card__content {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.Card__container {\r\n  display: inline-block;\r\n  padding: 15px;\r\n  text-align: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 3px;\r\n  background: #3e2b50;\r\n  color: white;\r\n  box-shadow: 5px 6px 9px 0px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\r\n  overflow: auto;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./demo/src/App.css
// module id = 11
// module chunks = 0 1